// @flow
import { Component, type Node } from 'react';

type ConfirmProps = {
  children: (boolean, () => void, () => void) => Node,
  // Milliseconds before confirmation reverts
  confirmTimeout?: number,
};

type ConfirmState = {
  confirmTimeoutId?: TimeoutID,
  isConfirming: boolean,
};

class Confirm extends Component<ConfirmProps, ConfirmState> {
  static defaultProps = {
    confirmTimeout: 3500,
  };

  constructor() {
    super();
    this.state = {
      confirmTimeoutId: undefined,
      isConfirming: false,
    };
  }

  componentWillUnmount() {
    this.clearConfirmationTimeout();
  }

  confirm = () => {
    this.clearConfirmationTimeout();
    this.setState({
      isConfirming: true,
      confirmTimeoutId: setTimeout(this.clearConfirmation, this.props.confirmTimeout),
    });
  };

  clearConfirmation = () => {
    this.setState({
      isConfirming: false,
    });
  };

  clearConfirmationTimeout() {
    if (this.state.confirmTimeoutId) {
      clearTimeout(this.state.confirmTimeoutId);
    }
  }

  render() {
    return this.props.children(this.state.isConfirming, this.confirm, this.clearConfirmation);
  }
}

export default Confirm;
